/**
 * @prettier
 */

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./print.css";
import "./theme/modern.css";
// sets the report's modern look as the app starts, as before (it came in with the one big
// bundle; the report page that imports it now loads later, see utils/lazyPage)
import "./theme/useKitTheme";
import { AppRouter } from "./Router";
import * as serviceWorker from "./serviceWorker";
import { reloadOnNewVersion } from "./utils/reloadOnNewVersion";

ReactDOM.render(<AppRouter />, document.getElementById("root"));
reloadOnNewVersion();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
